var map = {
	".": 332,
	"./": 332,
	"./Component": 1059,
	"./Component.js": 1059,
	"./OldUi": 1060,
	"./OldUi.js": 1060,
	"./RenderComponent": 763,
	"./RenderComponent.js": 763,
	"./TopActions": 762,
	"./TopActions.js": 762,
	"./index": 332,
	"./index.js": 332,
	"./style": 427,
	"./style.js": 427
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4212;
module.exports = webpackAsyncContext;